import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";

import { FileIcons, SocialIcons } from "./components/svgs";

import "@splidejs/splide/dist/css/splide.min.css";
import "normalize.css/normalize.css";
import "react-loading-skeleton/dist/skeleton.css";

import App from "./App";

const baseConfig = () => {
    // Тот же адрес бэкенда, что у сторов (VITE_BASE_URL), чтобы dev и staging не ходили в прод
    window.global = {
        baseUrl: process.env.REACT_APP_BASE_URL,
    };

    window.global.makeid = (length) => {
        var result = "";
        var characters =
            "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        var charactersLength = characters.length;

        for (var i = 0; i < length; i++) {
            result += characters.charAt(
                Math.floor(Math.random() * charactersLength),
            );
        }

        return result;
    };

    window.global.buildFormData = (formData, data, parentKey) => {
        if (!parentKey && (data == null || data === undefined)) {
            return;
        }

        if (
            data &&
            typeof data === "object" &&
            !(data instanceof Date) &&
            !(data instanceof File)
        ) {
            Object.keys(data).forEach((key) => {
                window.global.buildFormData(
                    formData,
                    data[key],
                    parentKey ? `${parentKey}[${key}]` : key,
                );
            });
        } else {
            const value = data == null ? "" : data;

            formData.append(parentKey, value);
        }
    };

    window.global.getSocialIcon = (text) => {
        if (text.includes("t.me/") || text.includes("@")) return SocialIcons.t;
        else if (text.includes("vk.com/")) return SocialIcons.vk;
        else if (text.includes("ok.ru/")) return SocialIcons.ok;
        else if (text.includes("mail.ru/")) return SocialIcons.my_mail;
        else if (text.includes("facebook.com/") || text.includes("fb.com/"))
            return SocialIcons.facebook;
        else if (text.includes("plus.google.com/")) return SocialIcons.google;
        else if (text.includes("linkedin.")) return SocialIcons.linkedin;
        else if (text.includes("twitter.com/")) return SocialIcons.twitter;
        else if (text.includes("instagram.com/")) return SocialIcons.instagram;
        else if (text.includes("youtu")) return SocialIcons.youtube;
        else if (text.includes("rutube")) return SocialIcons.rutube;
        else if (text.includes("tilda.ws")) return SocialIcons.tilda;
        else return SocialIcons.default;
    };

    window.global.truncateString = (str, num) => {
        if (!str) return "";

        // If the length of str is less than or equal to num
        // just return str--don't truncate it.
        if (str && str.length <= num) {
            return str;
        }
        // Return str truncated with '...' concatenated to the end of str.
        return str.slice(0, num) + "...";
    };

    window.global.declOfNum = (number, words) => {
        return words[
            number % 100 > 4 && number % 100 < 20
                ? 2
                : [2, 0, 1, 1, 1, 2][
                      number % 10 < 5 ? Math.abs(number) % 10 : 5
                  ]
        ];
    };

    axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
    axios.defaults.headers.post["Content-Type"] =
        "application/json;charset=utf-8";
};

baseConfig();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
